export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    menuList: [
      {
        groupIdx: 1,
        menuIdx: 1,
        name: "행사 바나나 \n와플",
        colorCss: "bg-pink",
        price: 4500,
        isOption: false,
        maxQty: 10,
        discount: 500,
        event: true,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 2,
        name: "브랙퍼스트 \n샌드위치",
        colorCss: "bg-ivory",
        price: 4200,
        isOption: false,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 2,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 3,
        name: "초콜렛 무스케이크",
        colorCss: "bg-pink",
        price: 4500,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 2,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 4,
        name: "초코머핀",
        colorCss: "bg-ivory",
        price: 3200,
        isOption: false,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 4,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 5,
        name: "도너츠",
        colorCss: "bg-pink",
        price: 2400,
        isOption: false,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 6,
        name: "잠봉외르 \n베이글",
        colorCss: "bg-ivory",
        price: 4500,
        isOption: false,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 7,
        name: "바닐라스콘",
        colorCss: "bg-pink",
        price: 3200,
        isOption: false,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 8,
        name: "딸기 \n조각케이크",
        colorCss: "bg-ivory",
        price: 4800,
        isOption: false,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 9,
        name: "딸기 롤케이크",
        colorCss: "bg-pink",
        price: 4500,
        isOption: false,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 54,
        name: "마르게리따 피자 세트",
        colorCss: "bg-setpink",
        price: 43000,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 2,
        cell: 1,
        optGrpCd: "SIZE001",
        setMenuIdx: 1,
      },
      {
        groupIdx: 1,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 1,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },

      {
        groupIdx: 2,
        menuIdx: 10,
        name: "행사 블랙티",
        colorCss: "bg-ivory",
        price: 4200,
        isOption: true,
        maxQty: 10,
        discount: 500,
        event: true,
        tagCode: "",
        row: 3,
        cell: 1,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 2,
        menuIdx: 11,
        name: "복숭아\n아이스티",
        colorCss: "bg-pink",
        price: 4000,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 3,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 2,
        menuIdx: 12,
        name: "얼그레이티",
        colorCss: "bg-ivory",
        price: 4200,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 2,
        menuIdx: 13,
        name: "녹차",
        colorCss: "bg-pink",
        price: 4200,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 2,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },

      {
        groupIdx: 3,
        menuIdx: 14,
        name: "아메리카노",
        colorCss: "bg-ivory",
        price: 4500,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 3,
        cell: 1,
        optGrpCd: "S003",
      },
      {
        groupIdx: 3,
        menuIdx: 15,
        name: "콜드브루",
        colorCss: "bg-ivory",
        price: 4500,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 3,
        optGrpCd: "S003",
      },
      {
        groupIdx: 3,
        menuIdx: 16,
        name: "카페라떼",
        colorCss: "bg-pink",
        price: 4800,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "S003",
      },
      {
        groupIdx: 3,
        menuIdx: 17,
        name: "카푸치노",
        colorCss: "bg-ivory",
        price: 4800,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "S003",
      },
      {
        groupIdx: 3,
        menuIdx: 18,
        name: "카라멜\n마키아토",
        colorCss: "bg-pink",
        price: 4800,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "S003",
      },
      {
        groupIdx: 3,
        menuIdx: 19,
        name: "연유라떼",
        colorCss: "bg-ivory",
        price: 5200,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 2,
        cell: 2,
        optGrpCd: "S003",
      },
      {
        groupIdx: 3,
        menuIdx: 20,
        name: "헤이즐넛라떼",
        colorCss: "bg-ivory",
        price: 4800,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "S003",
      },
      {
        groupIdx: 3,
        menuIdx: 21,
        name: "모카라떼",
        colorCss: "bg-pink",
        price: 5200,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "S003",
      },
      {
        groupIdx: 3,
        menuIdx: 22,
        name: "스레니쉬라떼",
        colorCss: "bg-pink",
        price: 5400,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "S003",
      },
      {
        groupIdx: 3,
        menuIdx: 23,
        name: "바닐라라떼",
        colorCss: "bg-ivory",
        price: 4800,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "S003",
      },
      {
        groupIdx: 3,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 3,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 3,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 3,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 3,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 3,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 3,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },

      {
        groupIdx: 4,
        menuIdx: 24,
        name: "행사 사과에이드",
        colorCss: "bg-pink",
        price: 5400,
        isOption: true,
        maxQty: 10,
        discount: 500,
        event: true,
        tagCode: "",
        row: 3,
        cell: 1,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 4,
        menuIdx: 25,
        name: "행사 블루레몬\n에이드",
        colorCss: "bg-ivory",
        price: 5400,
        isOption: true,
        maxQty: 10,
        discount: 500,
        event: true,
        tagCode: "",
        row: 1,
        cell: 3,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 4,
        menuIdx: 26,
        name: "레몬에이드",
        colorCss: "bg-pink",
        price: 4000,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 4,
        menuIdx: 27,
        name: "오렌지에이드",
        colorCss: "bg-ivory",
        price: 5400,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 4,
        menuIdx: 28,
        name: "레드베리\n에이드",
        colorCss: "bg-pink",
        price: 5600,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 4,
        menuIdx: 29,
        name: "그레이프후르츠에이드",
        colorCss: "bg-ivory",
        price: 5600,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 2,
        cell: 2,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 4,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 4,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 4,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 4,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 4,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 4,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 4,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 4,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 4,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 4,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 4,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },

      {
        groupIdx: 5,
        menuIdx: 30,
        name: "망고 스무디",
        colorCss: "bg-pink",
        price: 5800,
        isOption: true,
        maxQty: 10,
        discount: 500,
        tagCode: "",
        row: 3,
        cell: 1,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 5,
        menuIdx: 31,
        name: "행사 말차 \n스무디",
        colorCss: "bg-ivory",
        price: 5800,
        isOption: true,
        maxQty: 10,
        discount: 500,
        event: true,
        tagCode: "",
        row: 1,
        cell: 3,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 5,
        menuIdx: 32,
        name: "오레오밀크 \n스무디",
        colorCss: "bg-pink",
        price: 6200,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 5,
        menuIdx: 33,
        name: "블루베리 \n스무디",
        colorCss: "bg-ivory",
        price: 5800,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 5,
        menuIdx: 34,
        name: "메론 스무디",
        colorCss: "bg-pink",
        price: 6200,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 5,
        menuIdx: 35,
        name: "딸기 스무디",
        colorCss: "bg-ivory",
        price: 5800,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 2,
        cell: 2,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 5,
        menuIdx: 36,
        name: "딸기 스무디",
        colorCss: "bg-pink",
        price: 5800,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 2,
        cell: 1,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 5,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 5,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 5,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 5,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 5,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 5,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 5,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 5,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 5,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },

      {
        groupIdx: 6,
        menuIdx: 37,
        name: "마르게리따 피자",
        colorCss: "bg-pink",
        price: 27500,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 2,
        cell: 2,
        optGrpCd: null,
      },
      {
        groupIdx: 6,
        menuIdx: 38,
        name: "알리오올리오 파스타",
        colorCss: "bg-pink",
        price: 17500,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 6,
        menuIdx: 39,
        name: "씨푸드 토마토 파스타",
        colorCss: "bg-ivory",
        price: 17500,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 6,
        menuIdx: 40,
        name: "연어 스테이크",
        colorCss: "bg-ivory",
        price: 29700,
        isOption: false,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 4,
        optGrpCd: null,
      },
      {
        groupIdx: 6,
        menuIdx: 41,
        name: "쉬림프 로즈 \n파스타",
        colorCss: "bg-ivory",
        price: 17500,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 6,
        menuIdx: 42,
        name: "갈릭 파스타",
        colorCss: "bg-pink",
        price: 16500,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 2,
        optGrpCd: null,
      },
      {
        groupIdx: 6,
        menuIdx: 43,
        name: "김치 필라프",
        colorCss: "bg-ivory",
        price: 17500,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 3,
        optGrpCd: null,
      },
      {
        groupIdx: 6,
        menuIdx: 44,
        name: "커리 크림 리조또",
        colorCss: "bg-pink",
        price: 16500,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 2,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 6,
        menuIdx: 45,
        name: "핫 칠리 베이컨 파스타",
        colorCss: "bg-pink",
        price: 17500,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 3,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 6,
        menuIdx: 54,
        name: "마르게리따 피자 세트",
        colorCss: "bg-setpink",
        price: 43000,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 2,
        cell: 1,
        optGrpCd: "SIZE001",
        setMenuIdx: 1,
      },
      {
        groupIdx: 6,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 7,
        menuIdx: 46,
        name: "핫 칠리 베이컨 파스타",
        colorCss: "bg-pink",
        price: 17500,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 3,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 7,
        menuIdx: 47,
        name: "쉬림프 로즈 \n파스타",
        colorCss: "bg-ivory",
        price: 17500,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 7,
        menuIdx: 48,
        name: "블루베리 \n스무디",
        colorCss: "bg-ivory",
        price: 5800,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 7,
        menuIdx: 49,
        name: "메론 스무디",
        colorCss: "bg-pink",
        price: 6200,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 7,
        menuIdx: 50,
        name: "딸기 스무디",
        colorCss: "bg-ivory",
        price: 5800,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 2,
        cell: 2,
        optGrpCd: "SIZE001",
      },
      {
        groupIdx: 7,
        menuIdx: 51,
        name: "초코머핀",
        colorCss: "bg-ivory",
        price: 3200,
        isOption: false,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 4,
        optGrpCd: null,
      },
      {
        groupIdx: 7,
        menuIdx: 52,
        name: "도너츠",
        colorCss: "bg-pink",
        price: 2400,
        isOption: false,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 7,
        menuIdx: 53,
        name: "잠봉외르 \n베이글",
        colorCss: "bg-ivory",
        price: 4500,
        isOption: false,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 7,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 7,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 7,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 7,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 7,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
      {
        groupIdx: 7,
        menuIdx: 54,
        name: "마르게리따 피자 세트",
        colorCss: "bg-setpink",
        price: 43000,
        isOption: true,
        maxQty: 10,
        discount: 0,
        event: false,
        tagCode: "",
        row: 2,
        cell: 1,
        optGrpCd: "SIZE001",
        setMenuIdx: 1,
      },
      {
        groupIdx: 7,
        menuIdx: 0,
        name: "",
        colorCss: "",
        price: "",
        isOption: false,
        maxQty: 0,
        discount: 0,
        event: false,
        tagCode: "",
        row: 1,
        cell: 1,
        optGrpCd: null,
      },
    ],
  },
};
